import { render, staticRenderFns } from "./SetupPromo.vue?vue&type=template&id=5ea001ea&"
import script from "./SetupPromo.vue?vue&type=script&lang=js&"
export * from "./SetupPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports